import ReturnReasonDetailModal from "../returnReasonDetailModal";
export default class ViewNoteModal extends ReturnReasonDetailModal {
  constructor(props: any) {
    super(props);
    this.state = {
      isModalOpen: false,
      closable: true,
      okText: "",
      cancelText: "",
      modalTitle: "Note",
    };
  }
}
